export enum AccountSelectionType {
SelectSpecific,
SelectParent,
DynamicMappings,
}
